export enum PayStatus {
    IN_BUCKET,
    CREATED,
    PAID,
}
